import api from './api';

const creditCardService = {
  getAll: async () => {
    const response = await api.get('/credit-cards');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/credit-cards/${id}`);
    return response.data;
  },
  
  create: async (creditCard) => {
    const response = await api.post('/credit-cards', creditCard);
    return response.data;
  },
  
  update: async (id, creditCard) => {
    const response = await api.put(`/credit-cards/${id}`, creditCard);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/credit-cards/${id}`);
    return response.data;
  }
};

export default creditCardService; 